import React, { useRef } from "react";
import getCorePersonalStore from "../stores/core/core-personal-store";
import getCoreUIStore from "../stores/core/core-ui-store";
import ET3Div from "../core/et3-div";
import { withLiteObserverAndTheme } from "../core/et3-enhanced-render";
import { TEt3Theme } from "../core/et3-theme";
import BlockerPages from "./blocker";
import ProfileDropdown from "./profile-dropdown/ProfileDropdown";
import Et3Loading from "../core/et3-loading";
import Et3NoPermission from "../core/et3-no-permission";
import Header from "./header";
import ET3DivRef from "../core/et3-div-ref";
import SideBar from "./side-bar";
import Et3AlertPopUp from "../core/et3-pop-up-alerts";
import Et3ConfirmationPopUp from "../core/et3-pop-up-confirmation";
import Et3ActionPopUp from "../core/et3-pop-up-actions";
import Et3TBWPopUp from "../core/et3-pop-up-tbw";
import ReactionHistoryPopUp from "./message-reactions/ReactionHistoryPopUp";
import BackToTop from "../core/et3-back-to-top";
import { isPositiveNumber } from "et3-type-guards";
import Login from "../routes/login";
import {
  HEADER_HEIGHT,
  WRAPPER_CONTENT_HEIGHT,
  WRAPPER_HEIGHT_LOGIN
} from "../constants/core-constants";

const PageWrapper = withLiteObserverAndTheme<{
  Page: React.ComponentType<{
    theme?: TEt3Theme;
  }>;
  isBlocker: boolean;
}>((props) => {
  const { Page, isBlocker, theme } = props;
  const { colors } = theme;
  const adminServiceIsActive = getCorePersonalStore().adminServiceIsActive();
  const shouldRotateDevice = getCoreUIStore().rotateDevice.get();
  const shouldShowPage = adminServiceIsActive && !shouldRotateDevice;
  const sideBarVisible = getCoreUIStore().shouldShowSideBar.get();
  const mainWidth = sideBarVisible ? 1620 : 1920;
  const et3PageDivRef = useRef<HTMLDivElement>(null);
  const isDefinedAdminId = isPositiveNumber(
    getCorePersonalStore().user.get().id
  );
  const wrapperHeight = isDefinedAdminId
    ? HEADER_HEIGHT + WRAPPER_CONTENT_HEIGHT
    : WRAPPER_HEIGHT_LOGIN;
  const wrapperStyle: React.CSSProperties = {
    overflowX: "hidden",
    width: "100%",
    minWidth: 0,
    height: "100vh",
    minHeight: 0
  };

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1920}
      height={wrapperHeight}
      fDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={wrapperStyle}
      onClick={() => {}}
    >
      <Et3AlertPopUp />
      <Et3ActionPopUp />
      {isDefinedAdminId ? (
        <React.Fragment>
          <BlockerPages />
          <ProfileDropdown />
          <Et3Loading />
          <ReactionHistoryPopUp />
          <Et3NoPermission />
          <Header />
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            withShadow={false}
            width={1920}
            height={WRAPPER_CONTENT_HEIGHT}
            fDirection="row"
            alignItems="flex-start"
            justifyContent="flex-start"
            color={colors.all.transparent}
            style={{
              flexGrow: 1,
              flexShrink: 1,
              width: "100%",
              minWidth: 0,
              height: "auto",
              minHeight: 0,
              overflow: "hidden"
            }}
            onClick={() => {}}
          >
            <SideBar />
            <ET3DivRef
              isScrollable={true}
              isExtendable={false}
              withShadow={false}
              width={mainWidth}
              height={WRAPPER_CONTENT_HEIGHT}
              fDirection="column"
              alignItems="flex-start"
              justifyContent="flex-start"
              color={colors.all.transparent}
              style={{
                overflowX: "hidden",
                height: "100%",
                minHeight: 0
              }}
              onClick={() => {}}
              refDiv={et3PageDivRef}
            >
              <Et3ConfirmationPopUp />
              <Et3TBWPopUp />
              {isBlocker ? (
                !shouldShowPage ? (
                  <BlockerPages />
                ) : null
              ) : !shouldShowPage ? null : (
                <Page />
              )}
              <BackToTop refDiv={et3PageDivRef} />
            </ET3DivRef>
          </ET3Div>
        </React.Fragment>
      ) : (
        <Login />
      )}
    </ET3Div>
  );
});
export default PageWrapper;
